var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/detail-config.ts
function defineDetailPage(config) {
  return config;
}
__name(defineDetailPage, "defineDetailPage");

// src/use-detail-page.ts
import { useState, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
__name(capitalize, "capitalize");
function useDetailPage(config, id, options) {
  const queryKey = config.queryKey ?? [
    config.resource,
    id
  ];
  const fetchFn = useCallback(() => config.fetchById(id), [
    config.fetchById,
    id
  ]);
  const query = useQuery({
    queryKey,
    queryFn: fetchFn,
    enabled: options?.enabled ?? true
  });
  const defaultTab = config.defaultTab ?? (config.tabs.length > 0 ? config.tabs[0].id : "");
  const urlAdapter = options?.urlAdapter;
  const [activeTab, setActiveTabState] = useState(() => {
    if (urlAdapter && config.tabUrlParam) {
      const params = urlAdapter.readParams();
      const tabParam = params[config.tabUrlParam];
      if (tabParam && config.tabs.some((t) => t.id === tabParam)) {
        return tabParam;
      }
    }
    return defaultTab;
  });
  const setActiveTab = useCallback((tab) => {
    setActiveTabState(tab);
    if (urlAdapter && config.tabUrlParam) {
      const current = urlAdapter.readParams();
      urlAdapter.writeParams({
        ...current,
        [config.tabUrlParam]: tab
      });
    }
  }, [
    urlAdapter,
    config.tabUrlParam
  ]);
  const [isEditing, setIsEditing] = useState(false);
  const startEditing = useCallback(() => setIsEditing(true), []);
  const cancelEditing = useCallback(() => setIsEditing(false), []);
  const pageTitle = capitalize(config.resource.replace(/-/g, " "));
  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
    activeTab,
    setActiveTab,
    isEditing,
    setIsEditing,
    startEditing,
    cancelEditing,
    pageTitle
  };
}
__name(useDetailPage, "useDetailPage");
export {
  defineDetailPage,
  useDetailPage
};
//# sourceMappingURL=index.js.map